/**
 * @generated SignedSource<<a58bdb7e0cb8c12c7e1ca74838e9d639>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CampaignTabs = "Closing" | "Finished" | "New" | "Popular" | "Recommended";
export type CategoryTypes = "body_care" | "child_teaching" | "dance" | "diet" | "diy" | "fashion" | "gadget" | "game" | "gourmet_sweet_report" | "hair_care" | "kids" | "life_style" | "makeup" | "movie" | "nail" | "other" | "pet" | "ranking" | "skin_care" | "travel" | "yoga";
export type ParentMediaType = "cast" | "instagram" | "other" | "tiktok" | "tiktok_go" | "twitter" | "youtube";
export type CampaignsFinishedScreenQuery$variables = {
  first: number;
  selectedCategories?: ReadonlyArray<CategoryTypes> | null;
  selectedHasMoney?: boolean | null;
  selectedHasProduct?: boolean | null;
  selectedPrefectures?: ReadonlyArray<string> | null;
  selectedSns?: ReadonlyArray<ParentMediaType> | null;
  tab: CampaignTabs;
};
export type CampaignsFinishedScreenQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CampaignsCampaigns">;
};
export type CampaignsFinishedScreenQuery = {
  response: CampaignsFinishedScreenQuery$data;
  variables: CampaignsFinishedScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "selectedCategories"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "selectedHasMoney"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "selectedHasProduct"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "selectedPrefectures"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "selectedSns"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tab"
},
v7 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "selectedCategories",
    "variableName": "selectedCategories"
  },
  {
    "kind": "Variable",
    "name": "selectedHasMoney",
    "variableName": "selectedHasMoney"
  },
  {
    "kind": "Variable",
    "name": "selectedHasProduct",
    "variableName": "selectedHasProduct"
  },
  {
    "kind": "Variable",
    "name": "selectedPrefectures",
    "variableName": "selectedPrefectures"
  },
  {
    "kind": "Variable",
    "name": "selectedSns",
    "variableName": "selectedSns"
  },
  {
    "kind": "Variable",
    "name": "tab",
    "variableName": "tab"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CampaignsFinishedScreenQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "kind": "FragmentSpread",
        "name": "CampaignsCampaigns"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "CampaignsFinishedScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "CampaignConnection",
        "kind": "LinkedField",
        "name": "campaigns",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CampaignEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Campaign",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "parentMediaType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "gifting",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "prType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isFavoriteCheck",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Banner",
                    "kind": "LinkedField",
                    "name": "banners",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "file",
                        "storageKey": null
                      },
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MCategory",
                    "kind": "LinkedField",
                    "name": "mCategory",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SocialNetwork",
                    "kind": "LinkedField",
                    "name": "socialNetwork",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "recruitmentEndOn",
                        "storageKey": null
                      },
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v7/*: any*/),
        "filters": [
          "tab",
          "selectedSns",
          "selectedCategories",
          "selectedHasMoney",
          "selectedHasProduct",
          "selectedPrefectures"
        ],
        "handle": "connection",
        "key": "CampaignsList_campaigns",
        "kind": "LinkedHandle",
        "name": "campaigns"
      }
    ]
  },
  "params": {
    "cacheID": "21f6b6c1d2131c027066611ae438b33a",
    "id": null,
    "metadata": {},
    "name": "CampaignsFinishedScreenQuery",
    "operationKind": "query",
    "text": "query CampaignsFinishedScreenQuery(\n  $first: Int!\n  $tab: CampaignTabs!\n  $selectedSns: [ParentMediaType!]\n  $selectedCategories: [CategoryTypes!]\n  $selectedHasMoney: Boolean\n  $selectedHasProduct: Boolean\n  $selectedPrefectures: [String!]\n) {\n  ...CampaignsCampaigns_46CzqD\n}\n\nfragment CampaignBigCampaign on Campaign {\n  id\n  parentMediaType\n  title\n  gifting\n  prType\n  isFavoriteCheck\n  banners {\n    file\n    id\n  }\n  mCategory {\n    name\n    id\n  }\n  socialNetwork {\n    recruitmentEndOn\n    id\n  }\n}\n\nfragment CampaignCampaign on Campaign {\n  id\n  parentMediaType\n  title\n  gifting\n  prType\n  isFavoriteCheck\n  banners {\n    file\n    id\n  }\n  mCategory {\n    name\n    id\n  }\n  socialNetwork {\n    recruitmentEndOn\n    id\n  }\n}\n\nfragment CampaignsCampaigns_46CzqD on Query {\n  campaigns(first: $first, tab: $tab, selectedSns: $selectedSns, selectedCategories: $selectedCategories, selectedHasMoney: $selectedHasMoney, selectedHasProduct: $selectedHasProduct, selectedPrefectures: $selectedPrefectures) {\n    edges {\n      node {\n        id\n        ...CampaignBigCampaign\n        ...CampaignCampaign\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b7538f4a47b3332cdb4b9f76cb7e378f";

export default node;
